<mat-card class='p-24 mat-elevation-z0'>
  <mat-card-content>
    <data-container-viewer
      [dataContainerService]='datACS'
      [fields]='formConfig.fields'
      [record]='record'
    ></data-container-viewer>
  </mat-card-content>
  @if (showActions) {
    <mat-card-actions [align]="'end'">
      @if (canEdit) {
        <button (click)='onEdit()' mat-flat-button color='accent'>{{'Modifica' | translate}}</button>
      }
    </mat-card-actions>
  }
</mat-card>